/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import {BookingPaidContext} from "pages/Front/Booking/BookingPaid";
import Loader from "components/Loader";
import {isResultSuccess} from "utils/paymentUtils";

const BookingPaymentStatus = () => {
    const {t} = useTranslation();
    const bookingPaidContext = useContext(BookingPaidContext);

    if (!bookingPaidContext?.hall) {
        return <Loader />;
    }
    return (
        <div
            className={
                "PaymentStatus bg-white py-4 rounded-2xl flex flex-col space-y-4 sm:space-y-6 lg:flex-wrap justify-center items-center px-4 sm:px-12 text-center text-primary-800"
            }
        >
            {isResultSuccess(bookingPaidContext.payment) && (
                <>
                    <h3 className={"text-base sm:text-lg font-black leading-4"}>{t("Thank you for your purchase!")}</h3>
                    <h4 className={"text-sm sm:text-base font-medium leading-4"}>{t("Confirmation with your booking details has been sent via E-mail")}</h4>
                </>
            )}
            {!isResultSuccess(bookingPaidContext.payment) && (
                <h3 className={"text-base sm:text-lg font-black text-cta-800"}>{t("Something went wrong with your purchase")}</h3>
            )}
        </div>
    );
};

export default BookingPaymentStatus;
